module.exports = __webpack_public_path__ + "static/media/IMG_1557.abfb5001.jpg";